import React from "react";

/** A person's initials on an `--info` disc: a member in Settings, an owner in Knowledge. */
export default function InitialsAvatar({ name, size = 32 }: { name: string; size?: number }) {
  const initials = name
    .split(/[\s@._-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
  return (
    <div
      aria-hidden="true"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.34) }}
      className="shrink-0 rounded-full bg-[var(--info-bg)] flex items-center justify-center font-semibold text-[var(--info-text)]"
    >
      {initials}
    </div>
  );
}
